/* ═══════════════════════════════════════════════
   1. PRODUCT PAGE – Checkbox handler
   ═══════════════════════════════════════════════ */
(function () {
  const checkbox = document.getElementById('PrintedGiftCardCheckbox');
  if (!checkbox) return;

  const PAID_ADDON_VARIANT_ID = Number(checkbox.dataset.addonVariantId);
  const FREE_ADDON_VARIANT_ID = Number(checkbox.dataset.addonFreeVariantId);

  function findRecipientCheckbox() {
    return (
      document.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]') ||
      document.querySelector('input[name*="__shopify_send_gift_card"]') ||
      document.querySelector('input[id*="Recipient"][type="checkbox"]') ||
      document.querySelector('input[name*="recipient"][type="checkbox"]')
    );
  }

  function setRecipientDisabled(disabled) {
    const recipient = findRecipientCheckbox();
    if (!recipient) return;
    recipient.disabled = disabled;
    if (disabled) {
      recipient.checked = false;
      recipient.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const label = recipient.closest('label') || recipient.parentElement;
    if (label) {
      label.style.opacity = disabled ? '0.5' : '';
      label.style.pointerEvents = disabled ? 'none' : '';
    }
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return await res.json();
  }

  function giftCardTotal(cart) {
    return cart.items
      .filter(i => i.gift_card === true)
      .reduce((sum, i) => sum + i.final_line_price, 0);
  }

  function pickVariantId(cart) {
    return giftCardTotal(cart) >= 10000 ? FREE_ADDON_VARIANT_ID : PAID_ADDON_VARIANT_ID;
  }

  function isAddonItem(item) {
    return item.variant_id === PAID_ADDON_VARIANT_ID
        || item.variant_id === FREE_ADDON_VARIANT_ID;
  }

  async function addVariant(variantId) {
    const fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: fd
    });
    if (!res.ok) throw new Error(await res.text());
  }

  async function removeLine(key) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    if (!res.ok) throw new Error(await res.text());
  }

  async function ensureCorrectVariant(cart) {
    const correctId = pickVariantId(cart);
    const existing = cart.items.find(i => isAddonItem(i));
    if (existing && existing.variant_id !== correctId) {
      await removeLine(existing.key);
      await addVariant(correctId);
    } else if (!existing) {
      await addVariant(correctId);
    }
  }

  // Sync checkbox from cart on load
  (async () => {
    try {
      const cart = await getCart();
      checkbox.checked = cart.items.some(i => isAddonItem(i));
      setRecipientDisabled(checkbox.checked);
    } catch (_) {}
  })();

  // Checkbox toggle
  checkbox.addEventListener('change', async () => {
    setRecipientDisabled(checkbox.checked);
    try {
      const cart = await getCart();
      const existing = cart.items.find(i => isAddonItem(i));
      if (checkbox.checked) {
        await ensureCorrectVariant(cart);
      } else {
        if (existing) await removeLine(existing.key);
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    } catch (e) {
      console.error('Gift card add-on error:', e);
      checkbox.checked = !checkbox.checked;
      setRecipientDisabled(checkbox.checked);
      alert('Sorry — we could not add the printed delivery option. Please try again.');
    }
  });
})();


/* ═══════════════════════════════════════════════
   2. CART PAGE – Variant swap & orphan cleanup
   ═══════════════════════════════════════════════ */
(function () {
  if (!window.location.pathname.startsWith('/cart')) return;

  const ADDON_PRODUCT_HANDLE = 'printed-gift-card-postal-delivery';
  const PAID_VARIANT_ID = 52955500282194;
  const FREE_VARIANT_ID = 52955500314962;

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return await res.json();
  }

  async function changeLine(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  async function addVariant(variantId) {
    const fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');
    await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: fd
    });
  }

  (async () => {
    const cart = await getCart();
    const hasGiftCard = cart.items.some(i => i.gift_card === true);
    const addonItem = cart.items.find(i => i.handle === ADDON_PRODUCT_HANDLE);

    // No gift card → remove addon
    if (!hasGiftCard && addonItem) {
      await changeLine(addonItem.key, 0);
      window.location.reload();
      return;
    }

    // Gift card + addon → ensure correct variant
    if (hasGiftCard && addonItem) {
      const giftTotal = cart.items
        .filter(i => i.gift_card === true)
        .reduce((sum, i) => sum + i.final_line_price, 0);

      const correctId = giftTotal >= 10000 ? FREE_VARIANT_ID : PAID_VARIANT_ID;

      if (addonItem.variant_id !== correctId) {
        await changeLine(addonItem.key, 0);
        await addVariant(correctId);
        window.location.reload();
      }
    }
  })().catch(() => {});
})();


/* ═══════════════════════════════════════════════
   3. GUARD – Runs everywhere (cart drawer, etc.)
   ═══════════════════════════════════════════════ */
(function () {
  const ADDON_PRODUCT_HANDLE = 'printed-gift-card-postal-delivery';
  const PAID_VARIANT_ID = 52955500282194;
  const FREE_VARIANT_ID = 52955500314962;

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return await res.json();
  }

  async function removeLineItemByKey(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  async function addVariant(variantId) {
    const fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');
    await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: fd
    });
  }

  async function enforce() {
    const cart = await getCart();
    const hasGiftCard = cart.items.some(i => i.gift_card === true);
    const addonItem = cart.items.find(i => i.handle === ADDON_PRODUCT_HANDLE);

    // Addon without gift card → remove
    if (!hasGiftCard && addonItem) {
      await removeLineItemByKey(addonItem.key);
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      if (window.location.pathname.startsWith('/cart')) {
        window.location.reload();
      }
      return;
    }

    // Gift card + addon → ensure correct variant
    if (hasGiftCard && addonItem) {
      const giftTotal = cart.items
        .filter(i => i.gift_card === true)
        .reduce((sum, i) => sum + i.final_line_price, 0);

      const correctId = giftTotal >= 10000 ? FREE_VARIANT_ID : PAID_VARIANT_ID;

      if (addonItem.variant_id !== correctId) {
        await removeLineItemByKey(addonItem.key);
        await addVariant(correctId);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        if (window.location.pathname.startsWith('/cart')) {
          window.location.reload();
        }
      }
    }
  }

  enforce().catch(() => {});

  document.addEventListener('cart:refresh', () => {
    enforce().catch(() => {});
  });
})();
